module.exports = __webpack_public_path__ + "img/done.2477c572.svg";